export default {
  setlogoUploadPercentage(state, payload) {
    state.logoUploadPercentage = payload.value;
  }
};
